import { Grid, Skeleton } from "@mui/material";
import { fieldHeader } from "../../../../../components/fields/field_header";

const ViewLicenseInformationSkeleton = () => {
  return (
    <>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Type of License Applying For", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Date of Application", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Application Submitted by", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Store Format", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      {/* The "Other Store Format" field is conditionally rendered */}
      <Grid item xs={12} md={12}>
        <Grid item>
          {fieldHeader("Name of Distribution Center or Wholesaler", true)}
        </Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Wholesaler Contact", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
    </>
  );
};

export default ViewLicenseInformationSkeleton;
